var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-side"},[_c('img',{attrs:{"src":require("../resource/img/sidebar.png")}})])
}]

export { render, staticRenderFns }